import React, { useState, useEffect, useContext } from 'react'
import { connect } from 'react-redux'
import moment from 'moment'

import { 
  getProjectList, 
  fetchProjectList,
  getTrainingClassList, 
  fetchTrainingClassList,
} from '../../../store/client'

import TableData from '../../../shared/ui/TableData'
import Button from '../../../shared/ui/Button'
import Link from '../../../shared/ui/Link'
import ListViewController from '../../../shared/ui/ListViewController'
import {capitalize} from '../../../shared/utilities/helpers'
import { NavigationContext } from '../../../shared/ui/NavigationController'
import StatusLabel from '../../../shared/ui/StatusLabel'

import { withStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import Box from '@material-ui/core/Box'

export const OrderStatusColor = {
  'Invite Sent': '#ffaa00',
  'Waiting for Proposal': '#0000cc',
  'Waiting for Revision': '#0000cc',
  'Proposal Received': '#00aa00',
  'Completed': '#000000',
  'Canceled': '#aaaaaa',
}

const styles = theme => ({
  root: {
  },
})

const OrderListController = ({ theme, classes, ...props }) => {
  const { isFetching, lastFetched, data, fetchProjectList } = props
  
  const navigationContext = useContext(NavigationContext)

  useEffect(() => {
    fetchProjectList()
  }, [])
  
  const [selectedGroupKey, setSelectedGroupKey] = useState("on-progress")
  
  const groups = [
    { key: 'draft', label: 'Draft' },
    { key: 'on-progress', label: 'On Progress' },
    // { key: 'draft-on-progress', label: 'On Progress' },
    { key: 'ordered', label: 'Completed' },
    { key: 'canceled', label: 'Canceled' },
  ]

  const columns = [
    { key: 'project_name', label: 'Course Name', variant: 'title' },
    { key: 'project_detail', label: 'Detail' },
    { key: 'submitted_at', label: 'Submitted'},
    { key: 'training_provider', label: 'Training Provider'},
    { key: 'status', label: 'Status', wordWrap: false },
  ]

  const draftColumns = [
    { key: 'project_name', label: 'Course Name', variant: 'title' },
    { key: 'project_detail', label: 'Detail' },
    { key: 'updated_at', label: 'Last Update' },
  ]

  const orderedColumns = [
    { key: 'project_name', label: 'Course Name', variant: 'title' },
    { key: 'project_detail', label: 'Detail' },
    { key: 'customer_type', label: 'Class Type'},
    { key: 'training_provider', label: 'Training Provider'},
    { key: 'status', label: 'Status', wordWrap: false },
  ]
  
  const canceledColumns = [
    { key: 'project_name', label: 'Course Name', variant: 'title' },
    { key: 'project_detail', label: 'Detail' },
    { key: 'canceled_at', label: 'Canceled At'},
    { key: 'training_provider', label: 'Training Provider'}
  ]
  
  const columnsByKey = {
    'draft': draftColumns,
    'on-progress': columns,
    'draft-on-progress': columns,
    'ordered': orderedColumns,
    'canceled': canceledColumns,
  }
  
  const getCellValue = (row, column) => {
    if (column.key == 'project_name') {
      if (row.course)
        return row.course.name
      else
        return `${row.title} (Custom Course)`      
    }
    else if(column.key == 'project_detail'){
        return row['delivery_method'] !== 'online' ? capitalize(row['delivery_method']) + ' Class' : capitalize(row['delivery_method']) + ' Class via '+row['delivery_app'] 
    } 
    else if(column.key == 'customer_type'){
        return row['customer_type'] === 'public' ? "Public Class" : "Private Class"
    }     
    else if (
        column.key === 'submitted_at' ||
        column.key === 'canceled_at' ||
        column.key === 'created_at' ||        
        column.key === 'updated_at'        
      ) {
        return row[column.key] ? moment(row[column.key]).fromNow() : '-'
    }
    else if (column.key == 'training_provider') {
        if (row.customer_type === 'public')
            return row.provider.name
        else if (row.selected_proposal)
            return row.selected_proposal.provider.name
            
        return (
            <Box>
                {row.providers.map(items =>
                  <Typography variant='body1'>
                      {items.name} (<b>{ items.provider_status })</b>
                  </Typography>  
                )}
            </Box>
        )
    } else if (column.key == 'status') {
      return (
        <StatusLabel
          color={OrderStatusColor[row.status] || '#555'}
          >
          { row.status }
        </StatusLabel> 
      )      
    }
  
    return row[column.key]
  }
  
  const getCellSecondaryValue = (row, column) => {
    if (column.key == 'project_name')
      return row.project_no ? row.project_no : ''
    else if(column.key == 'project_detail')
      return `${moment(row.training_date).format('DD MMM YYYY')}, ${row.training_days} day${row.training_days > 1 ? "s" : ""}, ${row.participant_count} pax`
  }
  
  const filterProjectList = (list, key) => {
    if (key == 'draft')
      return list.filter(p =>
        p.customer_type === 'private' && !p.canceled_at && !p.submitted_at
        )
    else if (key == 'draft-on-progress')
      return list.filter(p =>
        p.customer_type === 'private' && !p.canceled_at && p.submitted_at && !p.selected_proposal
        )        
    else if (key == 'on-progress')
      return list.filter(p =>
        p.customer_type === 'private' && !p.canceled_at && p.submitted_at && !p.selected_proposal
        )
    else if (key == 'ordered')
      return list.filter(p =>
        !p.canceled_at && p.submitted_at && p.customer_type !== 'public' && p.selected_proposal
        )            
    else if (key == 'canceled')
      return list.filter(p =>
        p.canceled_at
        )
    else
      return []    
  }

  const rowCountProject = (key) => {
    let projectData = data.records
    if (key == 'draft')
      return projectData.filter(p =>
        p.customer_type === 'private' && !p.canceled_at && !p.submitted_at
        ).length
    else if (key == 'draft-on-progress')
      return projectData.filter(p =>
        p.customer_type === 'private' && !p.canceled_at && p.submitted_at && !p.selected_proposal
        ).length     
    else if (key == 'on-progress')
      return projectData.filter(p =>
        p.customer_type === 'private' && !p.canceled_at && p.submitted_at && !p.selected_proposal
        ).length
    else if (key == 'ordered')
      return projectData.filter(p =>
        !p.canceled_at && p.submitted_at && p.customer_type !== 'public' && p.selected_proposal
        ).length            
    else if (key == 'canceled')
      return projectData.filter(p =>
        p.canceled_at
        ).length
    else
      return 0
  }
  
  const showProjectDetail = (row) => {
    navigationContext.openLink(`/company/order/view/${row.uid}`)
  }
  
  const projectList = (
      lastFetched && filterProjectList(data.records, selectedGroupKey)
    ) || []  
    
  return (
    <ListViewController
      title="Order List"
      groups={groups}
      columns={columnsByKey[selectedGroupKey]}
      lastFetched={lastFetched}      
      isFetching={isFetching}
      selectedGroupKey={selectedGroupKey}
      onGroupChange={group => setSelectedGroupKey(group.key)}
      getRowsCount={rowCountProject}
      rows={projectList}
      getCellValue={getCellValue}
      getCellSecondaryValue={getCellSecondaryValue}
      onRowClick={(row) => showProjectDetail(row)}
      >
      <Box mt={2} />
      
      {/* { selectedGroupKey == 'on-progress' && lastFetched && projectList.length <= 0 &&
        <>
          <Typography gutterBottom>
            You have no pending order.
          </Typography>
          <Button variant='contained' component={Link} to='/'>
            Browse Courses
          </Button>
        </>
      } */}
      
      {/* { projectList.length > 0 && */}
        {/* <TableData
          columns={columnsByKey[selectedGroupKey]}
          rows={projectList}
          getCellValue={getCellValue}
          getCellSecondaryValue={getCellSecondaryValue}
          onRowClick={(row) => showProjectDetail(row)}
        /> */}
      {/* } */}

      { lastFetched && projectList.length <= 0 &&
        <Box mt={2} display='flex' justifyContent='center'>
          <Typography variant='body1'>
            You have no orders {selectedGroupKey.replace(/-/gi, ' ')}.
          </Typography>
        </Box>
      }
      
    </ListViewController>
  )
}

const mapStateToProps = (state, ownProps) => {
  const projectList = getProjectList(state)
  const trainingClassList = getTrainingClassList(state)
  
  if (projectList.lastFetched && trainingClassList.lastFetched) {
    let records = []
    
    if (projectList.lastFetched)
      records.push(...projectList.data.records.map(p => ({
          ...p,
          customer_type: 'private'
        })))
    if (trainingClassList.lastFetched)
      records.push(...trainingClassList.data.records.filter(t => t.customer_type === 'public')
        .map(t => ({
          ...t,          
        })))
  
    return {
      ...projectList,
      isFetching: projectList.isFetching || trainingClassList.isFetching,
      data: { records }
    }    
  }
  else {
    return {
      ...projectList,
      lastFetched: null,
      isFetching: projectList.isFetching || trainingClassList.isFetching
    }
  }  
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    fetchProjectList: () => {
      dispatch(fetchProjectList(true))
      dispatch(fetchTrainingClassList(true))      
    },    
  }
}

export default withStyles(styles, { withTheme: true })(
  connect(
    mapStateToProps,
    mapDispatchToProps
   )(OrderListController)
)
